import { Link } from "react-router-dom";
import { ArrowRight, GitCompareArrows, Check } from "lucide-react";
import { padNum, localizeSpirit } from "../../data/goetia";
import { useLang } from "../../config/i18n";

export const SpiritCard = ({ spirit: raw, inCompare, onToggleCompare }) => {
  const { lang, t } = useLang();
  const spirit = localizeSpirit(raw, lang);
  const g = t.goetia;

  return (
  <article
    data-testid={`spirit-card-${spirit.slug}`}
    className="group relative h-full p-6 rounded-xl bg-[#121216] border border-[#22222B] hover:border-[#C5A059]/50 hover:shadow-[0_0_40px_-12px_rgba(197,160,89,0.35)] transition-all duration-500 flex flex-col"
  >
    <div className="flex items-start justify-between mb-5">
      <span className="font-heading text-2xl gold-text font-light">{padNum(spirit.n)}</span>
      <div className="relative w-16 h-16 shrink-0">
        <div className="absolute -inset-1.5 rounded-full border border-[#C5A059]/35 group-hover:border-[#C5A059]/60 transition-colors duration-500" />
        <img
          src={spirit.sigil}
          alt={`Sigilo de ${spirit.name} — Ars Goetia`}
          loading="lazy"
          className="w-full h-full object-contain sigil-gold rounded-full bg-[#0D0D10] p-2.5"
        />
      </div>
    </div>

    <h3 className="font-heading text-xl tracking-[0.08em] text-[#F7F7F8] uppercase mb-1.5">{spirit.name}</h3>
    <p className="text-[10px] font-semibold tracking-[0.2em] uppercase text-[#C5A059] mb-1">
      {spirit.ranks.join(` ${lang === "en" ? "and" : "e"} `)}
    </p>
    <p className="text-[11px] text-[#6E6E7D] mb-4">
      {spirit.legions} {g.legionsSuffix}
    </p>

    <ul className="space-y-2 mb-6 flex-1">
      {spirit.attributes.slice(0, 3).map((a) => (
        <li key={a} className="flex items-start gap-2.5 text-xs text-[#A3A3AF] font-light leading-relaxed">
          <span className="mt-[6px] w-1 h-1 rotate-45 bg-[#C5A059] shrink-0" />
          {a}
        </li>
      ))}
    </ul>

    <div className="flex items-center gap-2.5">
      <Link
        data-testid={`spirit-profile-link-${spirit.slug}`}
        to={`/goetia/${spirit.slug}`}
        className="flex-1 inline-flex items-center justify-center gap-2 min-h-[44px] rounded-sm border border-[#C5A059]/50 text-[#C5A059] text-[10px] font-bold tracking-[0.16em] uppercase hover:bg-[#D9A94A] hover:text-[#0A0A0C] hover:border-[#D9A94A] transition-colors duration-300"
      >
        {g.viewProfile} <ArrowRight size={13} />
      </Link>
      <button
        data-testid={`spirit-compare-btn-${spirit.slug}`}
        onClick={() => onToggleCompare(spirit.slug)}
        aria-label={`${g.compare} ${spirit.name}`}
        className={`w-11 h-11 shrink-0 rounded-sm border flex items-center justify-center transition-colors duration-300 ${
          inCompare
            ? "bg-[#D9A94A] text-[#0A0A0C] border-[#D9A94A]"
            : "border-[#22222B] text-[#6E6E7D] hover:border-[#C5A059]/50 hover:text-[#C5A059]"
        }`}
      >
        {inCompare ? <Check size={16} /> : <GitCompareArrows size={16} />}
      </button>
    </div>
  </article>
  );
};
